"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var utils_1 = require("../../utils");
var StationPreview_1 = __importDefault(require("./StationPreview"));
var StationQR_1 = __importDefault(require("./StationQR"));
var hooks_1 = require("../../modules/categories/hooks");
var hooks_2 = require("../../modules/sections/hooks");
var hooks_3 = require("../../modules/stations/hooks");
var CategoryTextRaw_1 = __importDefault(require("../categories/CategoryTextRaw"));
var SectionText_1 = __importDefault(require("../sections/SectionText"));
var styles = {
    id: { fontFamily: "monospace" },
    revision: { marginTop: 16 },
    stationPreviewContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
    },
};
var stationDetailTitle = (0, utils_1.detailTitle)("Station", "title");
var StationDetailView = react_1.default.memo(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var stationID = (0, react_router_dom_1.useParams)().id;
    var _t = (0, hooks_3.useStations)(), stations = _t.items, stationsInitialFetch = _t.initialFetchDone, stationsFetching = _t.isFetching;
    var station = (0, react_1.useMemo)(function () { return (0, utils_1.findItemByID)(stations, stationID); }, [stations, stationID]);
    var sections = (0, hooks_2.useSections)().itemsByID;
    var categories = (0, hooks_1.useCategories)().itemsByID;
    var _u = (0, react_1.useState)(false), qrModalOpen = _u[0], setQrModalOpen = _u[1];
    var onBack = (0, react_1.useCallback)(function () { return navigate(-1); }, [navigate]);
    var showQrModal = (0, react_1.useCallback)(function () { return setQrModalOpen(true); }, []);
    var hideQrModal = (0, react_1.useCallback)(function () { return setQrModalOpen(false); }, []);
    var editStation = (0, react_1.useCallback)(function () { return navigate("/stations/edit/".concat(stationID)); }, [navigate, stationID]);
    var title = (0, react_1.useMemo)(function () { return stationDetailTitle(station, stationsInitialFetch, stationsFetching); }, [stationsInitialFetch, stationsFetching, station]);
    var extra = (0, react_1.useMemo)(function () { return [
        react_1.default.createElement(antd_1.Button, { key: "qr", icon: react_1.default.createElement(icons_1.QrcodeOutlined, null), onClick: showQrModal }, "QR Code"),
        react_1.default.createElement(antd_1.Button, { key: "edit", icon: react_1.default.createElement(icons_1.EditOutlined, null), onClick: editStation }, "Edit"),
    ]; }, [showQrModal, editStation]);
    if (station === undefined) {
        if (!stationsInitialFetch || stationsFetching) {
            return (react_1.default.createElement(antd_1.PageHeader, { ghost: false, onBack: onBack, title: react_1.default.createElement(antd_1.Skeleton, { active: true, paragraph: false }) },
                react_1.default.createElement(antd_1.Skeleton, { active: true })));
        }
        else {
            return (react_1.default.createElement(antd_1.Result, { status: "error", title: "Station not found", subTitle: "Station with ID ".concat(stationID, " could not be found."), extra: [
                    react_1.default.createElement(antd_1.Button, { type: "primary", key: "go-to-list", onClick: function () { return navigate("/stations/list"); } }, "See all stations")
                ] }));
        }
    }
    var section = sections[station.section];
    var category = categories[station.category];
    var enabled = station.enabled ? "Yes" : "No";
    return react_1.default.createElement(antd_1.PageHeader, { ghost: false, onBack: onBack, title: title, extra: extra },
        react_1.default.createElement(antd_1.Modal, { open: qrModalOpen, onCancel: hideQrModal, footer: null }, station ? react_1.default.createElement(StationQR_1.default, { station: station }) : null),
        react_1.default.createElement(antd_1.Descriptions, { bordered: true, size: "small", column: 3 },
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "ID", span: 1 },
                react_1.default.createElement("span", { style: styles.id }, station.id)),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Section", span: 1 },
                react_1.default.createElement(SectionText_1.default, { id: station.section })),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Category", span: 1 }, section && category && (react_1.default.createElement(CategoryTextRaw_1.default, { id: station.category, path: category.icon_svg, color: section.color }))),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Title", span: 1 }, station.title),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Long Title", span: 2 }, station.long_title),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Subtitle", span: 3 }, station.subtitle),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Coordinates", span: 3 }, (_b = (_a = station.coordinates_utm) === null || _a === void 0 ? void 0 : _a.crs) !== null && _b !== void 0 ? _b : "",
                "\u00A0 Zone\u00A0", (_d = (_c = station.coordinates_utm) === null || _c === void 0 ? void 0 : _c.zone) !== null && _d !== void 0 ? _d : "",
                "\u00A0", (_f = (_e = station.coordinates_utm) === null || _e === void 0 ? void 0 : _e.north) !== null && _f !== void 0 ? _f : "",
                "N\u00A0", (_h = (_g = station.coordinates_utm) === null || _g === void 0 ? void 0 : _g.east) !== null && _h !== void 0 ? _h : "",
                "E"),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Visible", span: 1 }, ((_j = station.visible) === null || _j === void 0 ? void 0 : _j.from) ? "".concat((_k = station.visible) === null || _k === void 0 ? void 0 : _k.from, " to ").concat((_l = station.visible) === null || _l === void 0 ? void 0 : _l.to) : enabled),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Enabled", span: 1 }, station.enabled ? "Yes" : "No"),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Rank", span: 1 }, station.rank)),
        react_1.default.createElement(antd_1.Descriptions, { bordered: true, size: "small", style: styles.revision },
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Revision", span: 1 },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/stations/revision/".concat(station.id) }, (_o = (_m = station.revision) === null || _m === void 0 ? void 0 : _m.number) !== null && _o !== void 0 ? _o : "")),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Update", span: 1 }, (_q = (_p = station.revision) === null || _p === void 0 ? void 0 : _p.message) !== null && _q !== void 0 ? _q : ""),
            react_1.default.createElement(antd_1.Descriptions.Item, { label: "Last Updated", span: 1 }, (_s = (0, utils_1.timestampToString)((_r = station.revision) === null || _r === void 0 ? void 0 : _r.timestamp)) !== null && _s !== void 0 ? _s : "")),
        react_1.default.createElement(antd_1.Divider, null),
        react_1.default.createElement("div", { style: styles.stationPreviewContainer },
            react_1.default.createElement(StationPreview_1.default, __assign({}, station))));
});
exports.default = StationDetailView;
